import {
  ExternalAccountDetails,
  ExternalAccountSubmissionType,
  ExternalBankAccountStatus,
} from '@/types/externalAccounts';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import ExternalAccountApproveButton from './ExternalAccountApproveButton';
import ExternalAccountDeleteButton from './ExternalAccountDeleteButton';
import { ExternalAccountDeclineButton } from './ExternalAccountDeclineButton';
import { SVButton } from '@/components/core';

type ExternalAccountDetailsButtonProps = {
  externalAccountDetails: ExternalAccountDetails;
};

export default function ExternalAccountDetailsButton({
  externalAccountDetails,
}: ExternalAccountDetailsButtonProps) {
  const navigate = useNavigate();
  const { isStaff } = useAuthUser();

  const {
    uuid,
    status,
    submissionType,
    accountNumberLast4,
    routingNumber,
    bankName,
    bankAddress,
    owner,
  } = externalAccountDetails;
  const isSubmitted = status === ExternalBankAccountStatus.SUBMITTED;
  const isDeleted = status === ExternalBankAccountStatus.DELETED;
  const isDigitalSubmission =
    submissionType === ExternalAccountSubmissionType.DIGITAL;
  const isCompleted =
    Boolean(accountNumberLast4) &&
    Boolean(routingNumber) &&
    Boolean(bankName) &&
    Boolean(bankAddress);

  const showVerifyButton = isStaff && isSubmitted && isCompleted;
  const showCompleteFormButton =
    !showVerifyButton && isStaff && isSubmitted && isDigitalSubmission;

  return (
    <>
      {showVerifyButton && (
        <>
          <ExternalAccountApproveButton id={uuid} />
          <ExternalAccountDeclineButton id={uuid} />
        </>
      )}
      {showCompleteFormButton && (
        <SVButton
          onClick={() => navigate(`${ROUTES.EXTERNAL_ACCOUNTS}/${uuid}/edit`)}
          fullWidth>
          Complete Form
        </SVButton>
      )}
      {!isDeleted && (
        <ExternalAccountDeleteButton id={uuid} ownerId={owner.uuid} />
      )}
    </>
  );
}
